<template>
  <div>
    <DialogBase
      title="Sửa đại lý"
      :visible.sync="isOpenUpdateBrandDialog"
      width="550px"
      panel-icon="el-icon-edit-outline"
      panel-title="CHỈNH SỬA THÔNG TIN ĐẠI LÝ"
      panel-subtitle="Cập nhật tên, trạng thái và thiết lập hạn mức số học sinh tối đa được sử dụng dịch vụ thanh toán."
      :confirm-loading="loading.submit"
      confirm-text="Cập nhật"
      cancel-text="Hủy bỏ"
      @before-close="handleClose"
      @cancel="handleClose"
      @confirm="submitForm"
      @open="handleOpen"
    >
      <el-form
        :model="formData"
        :rules="rules"
        ref="formData"
        label-position="top"
        class="modern-form"
      >
        <el-form-item label="Tên đầy đủ đại lý" prop="full_name">
          <el-input
            v-model="formData.full_name"
            placeholder="Nhập tên đầy đủ..."
            maxlength="200"
            show-word-limit
          />
        </el-form-item>

        <el-form-item label="Tên viết tắt (mã nhận diện)" prop="short_name">
          <el-input
            v-model="formData.short_name"
            placeholder="Nhập tên viết tắt..."
            maxlength="20"
            show-word-limit
          />
        </el-form-item>

        <el-form-item label="Trạng thái hoạt động" prop="status">
          <el-select v-model="formData.status" placeholder="Chọn trạng thái" class="full-width">
            <el-option
              v-for="item in statusBrand"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="Học sinh tối đa" prop="numberOnlinePayments">
              <el-input-number
                v-model="formData.numberOnlinePayments"
                :min="0"
                class="full-width-number"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Cấu hình hạn mức" prop="onlinePaymentLimit" class="pt-item">
              <el-checkbox v-model="formData.onlinePaymentLimit" class="modern-checkbox">
                Giới hạn học sinh
              </el-checkbox>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </DialogBase>
  </div>
</template>

<script>
import DialogBase from "@/components/DialogBase.vue";
import { statusBrand } from "@/constant/listCommon";
import sePayConnectionService from "@/services/SePayConnectionService";
import NotifyMessage from "@/commonFuncion/NotifyMessage";

export default {
  name: "UpdateBrandDialogVersion2",
  components: { DialogBase },
  props: {
    isOpenUpdateBrandDialog: {
      type: Boolean,
      default: () => false
    },
    brand: {
      type: Object,
      default: () => null
    }
  },

  data() {
    return {
      statusBrand,
      formData: {
        full_name: "",
        short_name: "",
        status: "",
        numberOnlinePayments: 0,
        onlinePaymentLimit: false,
        xid: ""
      },
      rules: {
        full_name: [
          {
            required: true,
            message: "Tên đầy đủ không được để trống!",
            trigger: "change"
          },
          { max: 200, message: "Tối đa 200 ký tự", trigger: "change" }
        ],
        short_name: [
          {
            required: true,
            message: "Tên viết tắt không được để trống",
            trigger: "change"
          },
          { max: 20, message: "Tối đa 20 ký tự", trigger: "change" },
          {
            pattern: /^[A-Z0-9]*$/,
            message: "Chỉ cho phép chữ cái in hoa (A-Z) và số",
            trigger: "change"
          }
        ],
        status: [
          {
            required: true,
            message: "Trạng thái không được để trống",
            trigger: "change"
          }
        ]
      },
      loading: {
        submit: false
      }
    };
  },

  methods: {
    handleClose() {
      this.$refs["formData"].resetFields();
      this.$emit("closeDialog");
    },
    
    handleOpen() {
      if (this.brand) {
        this.formData.full_name = this.brand.full_name || "";
        this.formData.short_name = this.brand.short_name || "";
        this.formData.status = this.brand.status || "";
        this.formData.numberOnlinePayments = this.brand.numberOnlinePayments || 0;
        this.formData.onlinePaymentLimit = this.brand.onlinePaymentLimit || false;
        this.formData.xid = this.brand.xid || "";
      }
    },
    
    async submitForm() {
      this.$refs["formData"].validate(async (valid) => {
        if (valid) {
          this.loading.submit = true;
          try {
            const resp = await sePayConnectionService.updateCompanyV2(this.formData);
            if (resp.data.data === true) {
              NotifyMessage.leftCornerNotificationSuccess("Cập nhật thành công!");
            } else {
              NotifyMessage.leftCornerNotificationError("Cập nhật thất bại!");
            }
            this.handleClose();
          } catch (err) {
            console.error(err);
            this.handleClose();
          } finally {
            this.loading.submit = false;
          }
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.modern-form {
  /deep/ .el-form-item {
    margin-bottom: 20px;
  }

  /deep/ .el-form-item__label {
    font-weight: 600;
    color: #475569;
    padding-bottom: 6px;
  }

  /deep/ .el-input__inner {
    border-radius: 8px;
    height: 40px;
  }
}

.full-width {
  width: 100% !important;
  
  /deep/ .el-input__inner {
    width: 100% !important;
  }
}

.full-width-number {
  width: 100% !important;
  
  /deep/ .el-input-number__decrease, /deep/ .el-input-number__increase {
    height: 38px;
    line-height: 38px;
  }
}

.pt-item {
  padding-top: 36px;
}

.modern-checkbox {
  font-weight: 600;
  color: #475569;
}
</style>